import { imageLoader } from "../../../utils/imageLoader";
import moment from "moment";
import useFavorites from "../../../utils/useFavorites";

const ListeProgrammesEnregistres = ({
  programmesFavoris,
  onProgramClick,
  filterInput,
  setFilterInput,
}) => {
  const {
    isProgramInFavorites,
    handleAddToFavorites,
  } = useFavorites();
  return (
    <div>
      {" "}
      <div className="table mt-4">
        {/* Header */}
        <div className="table-fav-prog-header pink text-center ">
          <div className="table-cell" title="Programme"><img src="./icons/programmes.svg" width={45} height={45} alt="Programme" /></div>
          <div className="table-cell" title="Livraison"><img src="./icons/delivery.svg" width={45} height={45} alt="Livraison" /></div>
          <div className="table-cell" title="Actabilité"><img src="./icons/actabilite.svg" width={45} height={45} alt="Actabilité" /></div>
          <div className="table-cell" title="Dispositif"><img src="./icons/project-types.svg" width={45} height={45} alt="Dispositif" /></div>
          <div className="table-cell" title="Lots dispo"><img src="./icons/lot-dispo.svg" width={45} height={45} alt="Lots dispo" /></div>
          <div className="table-cell" title="Typologies"><img src="./icons/typologie.svg" width={45} height={45} alt="Typologies" /></div>
          <div className="table-cell" title="Prix"><img src="./icons/prix.svg" width={45} height={45} alt="Prix" /></div>
          <div className="table-cell" title="Favoris"><img src="./icons/favoris.svg" width={45} height={45} alt="Favoris" /></div>
        </div>
        {/* Rows */}
        {programmesFavoris?.length > 0 ? (
          programmesFavoris.map((programme) => (
            <div
              key={programme.documentId}
              className="tables-rows-fav-prog cursor-pointer hoverborder"
              onClick={() => onProgramClick(programme.documentId)}
            >
              {/* Programme */}
              <div className="table-cells p-0">
                <div className="d-flex align-items-center gap-2 p-0 radiusTL5 radiusBL5">
                  <div className="program-image">
                    <img
                      src={imageLoader(
                        programme.lots[0]?.images[0]?.image[0]?.url
                      )}
                      alt=""
                    />
                  </div>
                  <div className="d-flex flex-column text-start gap16">
                    <div>
                      <p
                        className="mb-0 fs16 darkGrey semibold name-column"
                        title={programme.name}
                      >
                        {programme.name}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {programme.address || "NC"}
                      </p>
                    </div>
                    <div>
                      <p className="mb-0 fs11 darkGrey semibold">
                        {programme.municipality || "NC"}
                      </p>
                      <p className="text-muted mb-0 fs11 darkGrey regular">
                        {programme.delivery_date
                          ? moment(programme.delivery_date).format("YYYY") +
                          " T-" +
                          moment(programme.delivery_date).quarter()
                          : "NC"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Livraison */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                {programme.delivery_date
                  ? moment(programme.delivery_date).format("YYYY") +
                  " T-" +
                  moment(programme.delivery_date).quarter()
                  : "NC"}
              </div>
              {/* Actabilité */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                {programme.is_actable ? "Immédiate" : "Pas Précisé"}
              </div>
              {/* Dispositif */}
              <div className="table-cells d-flex align-items-center justify-content-center">
                <div className="d-flex flex-column gap-2">
                  <span className="badge bg-green">{"Droit commun"}</span>
                  <div className="d-flex justify-content-between">
                    {["PTZ", "RP neuf"].map((badge, index) => (
                      <span
                        key={index}
                        className={`badge bg-${badge
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                      >
                        {badge}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              {/* Lots Dispo */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                {programme?.lots?.length ? programme?.lots?.length : "NC"}
              </div>
              {/* Typologies */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                {(() => {
                  const typologies = programme?.lots?.reduce((acc, lot) => {
                    if (lot.typology && lot.typology !== "unknown" && !acc.includes(lot.typology)) {
                      acc.push(lot.typology);
                    }
                    return acc;
                  }, []);

                  return typologies?.length > 0 ? typologies.join('-') : "NC";
                })()}
              </div>
              {/* Prix */}
              <div className="table-cells d-flex align-items-center justify-content-center">
                <div className="text-center">
                  <p className="text-muted fs16 semibold darkGrey">
                    De{" "}
                    {programme?.lots[0]?.price_total
                      ? Intl.NumberFormat("fr-FR").format(
                        programme?.lots[0]?.price_total
                      )
                      : "NC"}
                  </p>
                  <p className="mb-0 fs16 semibold darkGrey">
                    à{" "}
                    {programme?.lots[programme?.lots?.length - 1]?.price_total
                      ? Intl.NumberFormat("fr-FR").format(
                        programme?.lots[programme?.lots?.length - 1]
                          ?.price_total
                      )
                      : "NC"}
                  </p>
                </div>
              </div>
              {/* Action */}
              <div className="table-cells text-center d-flex align-items-center justify-content-center">
                <img
                  src={
                    isProgramInFavorites(programme.documentId)
                      ? "./icons/favorite-filled.svg"
                      : "./icons/favorite-outline.svg"
                  }
                  alt="favorite"
                  height={35}
                  width={35}
                  className="cursor-pointer p-0"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToFavorites(programme.documentId, "Programme");
                  }}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">Pas de programmes favoris</div>
        )}
      </div>
    </div>
  );
};

export default ListeProgrammesEnregistres;
